import { useCallback, useMemo } from 'react'

import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { InspectionArea, InspectionItemType } from '@editor/interfaces/inspection'
import { zeroPad } from '@editor/services/Util'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

const usePolyline = (): ElementsPanelConfig => {
  // Store
  const checkedEditorElements = useSelector((state: RootState) => state.blueprint.drawings.document.editorElements)

  // Context
  const inspectionItems = useSelector((state: RootState) => state.inspectionItems.items)

  const polylines = useMemo(
    () => inspectionItems.filter((item) => item.item_type === InspectionItemType.PolylineLength),
    [inspectionItems],
  )

  return {
    getPanelItems: useCallback(
      (parent?: EditorPanelItem['item'], area?: InspectionArea): EditorPanelItem[] => {
        // Polyline is parent-level, ignore if parent is provided
        if (parent) return [] as EditorPanelItem[]

        const lines = polylines.filter((item) => !area || item.inspection_area_id === area.inspection_area_id)

        if (lines.length) {
          return [
            {
              key: 'panel-polyline',
              name: '延長',
              isVirtualContainer: true,
              isCountable: true,
              onSelect: false,
              onHover: true,
              isCheckable: true,
              aggregateSelection: true,
              children: [
                ...lines.map<EditorPanelItem>((item, index) => ({
                  key: `panel-polyline-${item.inspection_item_id}`,
                  name: item?.part_name || `延長${zeroPad(index + 1, 3)}`,
                  item,
                  order: item.order_in_inspection_group,
                  isGrouped: !!item.inspection_group_id,
                  isOrderable: false,
                  isCheckable: true,
                  isChecked: checkedEditorElements.inspectionItems.some((row) => row.id === item.inspection_item_id),
                  onDelete: false,
                  onHover: true,
                })),
              ],
            },
          ]
        }

        return []
      },
      [polylines, checkedEditorElements.inspectionItems],
    ),
  }
}

export default usePolyline
